// Shortcut help (UX spec 10): every shortcut this build has, grouped, from lib/shortcuts.ts. Opened
// with "?" (unless turned off in Settings), from the command palette and from the account menu. A
// modal dialog: Esc or Close dismisses it and focus goes back where it was. No motion.
import { Dialog } from '../ui/Dialog.tsx';
import { Keys } from '../ui/Keys.tsx';
import { type Platform, SHORTCUT_GROUPS } from '../lib/shortcuts.ts';

export function ShortcutHelp({ open, onClose, platform }: { open: boolean; onClose: () => void; platform: Platform }) {
  return (
    <Dialog open={open} title="Keyboard shortcuts" onClose={onClose} className="shortcut-help" focusTitle
      footer={<button type="button" className="btn" onClick={onClose}>Close</button>}>
      {open ? <ShortcutList platform={platform} /> : null}
    </Dialog>
  );
}

export function ShortcutList({ platform }: { platform: Platform }) {
  return (
    <>
      <p className="shortcut-note">
        {platform === 'mac' ? 'Shown with Mac keys.' : 'On a Mac, use Cmd for Ctrl and Option for Alt.'} Press Esc to close this list.
      </p>
      <div className="shortcut-groups">
        {SHORTCUT_GROUPS.map(group => (
          <table key={group.id} className="shortcut-table">
            <caption>
              {group.title}
              {group.note ? <span className="shortcut-where">{group.note}</span> : null}
            </caption>
            <tbody>
              {group.items.map(item => (
                <tr key={item.id}>
                  <th scope="row">
                    {item.action}
                    {item.where ? <span className="shortcut-where">{item.where}</span> : null}
                  </th>
                  <td><Keys keys={item.keys} platform={platform} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        ))}
      </div>
    </>
  );
}
